import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk6() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`VI.`}
            <br />
            {`Podmienky poskytovania služby`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Používateľ nesmie v rámci služby šíriť informácie, obsah ktorých je v rozpore s dobrými mravmi či s všeobecne záväznými právnymi predpismi.`}</li>
            <li>{`Používateľ nesmie v rámci služby používať mechanizmy, nástroje, programové vybavenie alebo postupy, ktoré majú alebo by mohli mať negatívny vplyv na prevádzku služby.`}</li>
            <li>{`Používateľ nesmie vyvíjať činnosť smerujúcu k tomu, aby bola znemožnená alebo obmedzená prevádzka služby či servera poskytovateľa, na ktorom služba funguje, alebo uskutočňovať iné útoky na tento server, ani nesmie byť pri takejto činnosti nápomocný tretej osobe. Používateľ nesmie používateľský účet a službu využívať spôsobom, ktorý by neprimerane obmedzoval pri používaní služby ďalších zákazníkov poskytovateľa či inak neprimerane obmedzoval poskytovateľa.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`Prístupové údaje k službe sú určené len pre jednu fyzickú osobu, prípadne pre spoločnú domácnosť v rámci rodinného predplatného, a sú neprenosné. Používateľ nemá právo poskytnúť, postúpiť, prenajímať, požičiavať ani inak umožňovať tretím osobám prístup k službe, trvalo či dočasne, úplatne či bezúplatne, a to bez predchádzajúceho písomného súhlasu poskytovateľa. Používateľ nie je oprávnený poskytovať prístupové údaje viacerým fyzickým osobám, a to ani vtedy, ak bude používateľom právnická osoba, v takomto prípade je právnická osoba povinná určiť jednu fyzickú osobu, ktorá bude mať do služby prístup. V prípade straty prístupových údajov alebo podozrenia na ich zneužitie či únik je používateľ povinný bezodkladne informovať poskytovateľa. Poskytovateľ nezodpovedá za škodu, ktorá by vznikla používateľovi zneužitím prístupu do služby bez zavinenia poskytovateľa. V prípade podozrenia na poskytnutie prístupu k službe je poskytovateľ oprávnený do overenia tejto skutočnosti na nutný čas prerušiť používateľovi prístup k službe s tým, že nárok na úplatu za príslušné obdobie týmto nie je dotknutý.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk6;
